import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import Table from '@empd/reactable'
import moment from 'moment'
import '@empd/reactable/lib/styles.css'

import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap' 

import CustomNavbar from '../../components/CustomNavbar'
import CustomFooter from '../../components/CustomFooter'
import MainContentSpaced from '../../components/MainContentSpaced'

import api from "../../service/api";

const Dashboard = (props) => {
    const [sendedToday, setSendedToday] = useState([])
    const [emptyDataElement, setEmptyDataElement] = useState(<Spinner animation="grow" />)
    
    useEffect(function () {
        async function loadDashboard () {
            const responseGetSendedToday = await api.get('/mala-direta-avulsa')
            if (responseGetSendedToday.data.error) {
                alert('Erro ao buscar as informacoes para o Dashboard. Contate o suporte!')
            } else {
                if (responseGetSendedToday.data.data.length === 0)
                    setEmptyDataElement(
                        <Alert variant="dark">
                            Não existem registros.
                        </Alert>
                    )
                else {
                    const getSendedTodayBeautiful = async () => {
                        return Promise.all(responseGetSendedToday.data.data.map((sendedTodayItem, index) => ({
                            client: `${sendedTodayItem.firstName} ${sendedTodayItem.lastName}`,
                            seller: `${sendedTodayItem.seller.firstName} ${sendedTodayItem.seller.lastName}`,
                            sended: sendedTodayItem.sended === true ? 'Sim' : 'Não',
                            sended_hour: moment(sendedTodayItem.createdAt).locale('pt-br').format('HH:mm')
                        })))
                    }
                    getSendedTodayBeautiful().then((sendedTodayBeautiful) => {
                        setSendedToday(sendedTodayBeautiful)
                    })
                    
                    
                }
                    
            }
        }

        loadDashboard()
    }, [])

    return (
        <>
            <CustomNavbar/>
            <MainContentSpaced>
                <Container>
                    <h3>Enviados Hoje (Total: { sendedToday.length })</h3>
                    <Row>
                        <Col> 
                            <Table
                                searchPlaceholder="Procurar"
                                emptyPlaceholder={emptyDataElement}                                
                                columns={
                                    [
                                        {
                                            name: 'Cliente',
                                            sortable: true,
                                            selector: 'client'
                                        },
                                        { 
                                            name: 'Gerente',
                                            sortable: true,
                                            selector: 'seller'
                                        },
                                        { 
                                            name: 'Confirmado Envio?',
                                            sortable: true,
                                            selector: 'sended'
                                        },
                                        {
                                            name: 'Horario de Envio',
                                            sortable: true,
                                            selector: 'sended_hour'
                                        },
                                    ]
                                }
                               data={sendedToday}
                            />
                        </Col>
                    </Row>
                </Container>
            </MainContentSpaced>
            <CustomFooter
            />
        </>
    )
}

export default withRouter(Dashboard)